export class AssociateCardModel {

    constructor(init?: Partial<AssociateCardModel>){
        Object.assign(this, init);
    }

    public code: string;
    public confirmCode: string;
    public password: string;
    public confirmPassword: string;
    public colaboratorID: number;
    public managerGuid: string;
    public assignorGuid: string;
    public existsUser: boolean;
}
